import { render, staticRenderFns } from "./FlipCard.vue?vue&type=template&id=0040a21b&scoped=true"
import script from "./FlipCard.vue?vue&type=script&lang=js"
export * from "./FlipCard.vue?vue&type=script&lang=js"
import style0 from "./FlipCard.vue?vue&type=style&index=0&id=0040a21b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040a21b",
  null
  
)

export default component.exports